//@flow
import {
  FEELING_CHANGE,
  FEELING_SUBMIT_REQUESTING,
  FEELING_PROGRESS_CHANGE,
  FEELING_GET_ONBOARDING_STATS_REQUESTING,
} from "./constants";

// je doit mettre le types feeling avec toutes les options ? même avec l'onboarding personnalisé ?
export const changeFeeling = payload => {
  return {
    type: FEELING_CHANGE,
    payload,
  };
};

// même remarque
export const submitFeelingRequest = payload => {
  return {
    type: FEELING_SUBMIT_REQUESTING,
    payload,
  };
};

export const changeProgress = (payload: number) => {
  return {
    type: FEELING_PROGRESS_CHANGE,
    payload,
  };
};

export const getOnboardingStatsRequest = (payload: { clientId: string }) => {
  return {
    type: FEELING_GET_ONBOARDING_STATS_REQUESTING,
    payload,
  };
};
